import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import { odata } from "../Filters/Helper";
import { ColumnHelper } from "util/TableHelper";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Tooltip,
  Popconfirm,
  Tabs,
  Form,
  Input,
  Modal
} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import ErpPosTransactionExpiryDateModal from "./ErpPosTransactionExpiryDateModal";
import ErpPosTransactionTableFilter from "../Filters/ErpPosTransactionTableFilter";
import ErpReportSummary, { SummaryDataList } from "./ErpReportSummary.js";
import { useMediaQuery } from "react-responsive";
function ErpPosTransaction() {
  const isBigScreen = useMediaQuery({
    query: "(min-device-width: 1824px)",
  });
  const isDefaultScreen = useMediaQuery({
    query: "(max-device-width: 1880px)",
  });

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [firm, setFirm] = useState([]);
  const [projects, setProjects] = useState({
    data: [],
    loading: false,
  });
  const [referenceCodes, setReferenceCode] = useState({ data: [], loading: false, });

  const [summaryData, setSummaryData] = useState({
    totals: [{ amount: 0, count: 0, currency: '' }],
    successes: [{ amount: 0, count: 0, currency: '' }],
    errors: [{ amount: 0, count: 0, currency: '' }],
    transferables: [{ amount: 0, count: 0, currency: '' }]
  });
  const [loadingSummary, setLoadingSummary] = useState(false)
  const [filterSummary, setFilterSummary] = useState(true)

  const [order, setOrder] = useState("");
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    activeTab: "0",
    filter: "",
  });


  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )})  and ProjectType eq 0 and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setProjects({ data: res.value, loading: false });
        } else {
          setProjects({ data: [], loading: false });
        }
      });
    }
  };

  const onReferenceCodeSearch = (value) => {
    if (value.length >= 1) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )})  and ProjectType eq 8 and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setReferenceCode({ data: res.value, loading: false });
        } else {
          setReferenceCode({ data: [], loading: false });
        }
      });
    }
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {

      var url = `/Firm/FirmDropdown?$select=id,firmBranchNumber,name,directiveName&$filter=${odata.contains(
        "name",
        value
      )} or ${odata.contains("firmBranchNumber", value)}`;

      if (showFirmTitle) {
        url = `${url} or ${odata.contains("directiveName", value)}`
      }

      RequestHandler.get(url).then((res) => {
        if (res) {
          setFirm(res);
        }
      });
    } else {
      setFirm([]);
    }
  };


  const getFilterQuery = (isSummary = false) => {
    const { filter, activeTab } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (activeTab !== "-1" && !isSummary) {
      conditions.push(`erpTransferStatusId Eq ${activeTab}`);
    }

    if (filter) {
      conditions.push(filter);
    } else if (isSummary) {
      const today = new Date();
      today.setMonth(today.getMonth() - 6);
      conditions.push(`transactionDate ge ${today.toISOString().split("T")[0]}`);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();

  const [tabKeyValue, setTabKeyValue] = useState();
  const [isHasExpiryDate, setIsHasExpiryDate] = useState(false);
  const [expiryDateModalVisible, setExpiryDateModalVisible] = useState(false);

  const [columnSettings, setColumnSettings] = useState();
  const [responsibilityCenter, setResponsibilityCenter] = useState({
    data: [],
    loading: true,
  });

  const [defaultResponsbilityCenter, setDefaultResponsbilityCenter] = useState(null);

  const [showFirmTitle, setShowFirmTitle] = useState(false);

    const [allowMarkAsTransfered, setAllowMarkAsTransfered] = useState(false);

  const cardTypeSelect = [
    { key: "1", value: "Ticari Hesap" },
    { key: "2", value: "Kredi Hesabı" },
    { key: "3", value: "Dövizli Ticari Hesap" },
    { key: "4", value: "Dövizli Kredi Hesabı" },
    { key: "5", value: "Kredi Kartı Hesabı" },
    { key: "6", value: "Dövizli Kredi Kartı Hesabı" },
  ];

  const getResponsibilityCenter = () => {
    RequestHandler.get(
      `/TransactionProjectType?$count=true&$filter=ProjectType eq 3 and IsActive eq true`
    ).then((response) => {

      const defaultResponsibilityCenter = response.value.filter(x => x.isDefault);

      if (defaultResponsibilityCenter.length > 0) {
        setDefaultResponsbilityCenter(defaultResponsibilityCenter[0].projectCode);
      }


      setResponsibilityCenter({
        data: response.value,
        loading: false
      });
    });
  };

  const isExportAvailable =
    tableDataQueryOptions.activeTab === "0" ||
    tableDataQueryOptions.activeTab === "3";

  useEffect(() => {
    getColumnSettings();
    getResponsibilityCenter();
    getTenantParameter();
  }, []);



  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  const setSummaryDataList = (response) => {
    setSummaryData(SummaryDataList(response));
    setLoadingSummary(false)
  }
  const getSummaryData = () => {
    setLoadingSummary(true)
    RequestHandler.get(
      `/ErpPosCollectionTransaction/GetSummary?$select=id,erpTransferStatusId,currency,amount,transactionDate${getFilterQuery(true)}${order}`
    ).then((response) => {
      setSummaryData(response)
      setLoadingSummary(false)
    });
  }

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setShowFirmTitle(response.data.isShowFirmTitle);
          setAllowMarkAsTransfered(response.data.markAsErpTransferdPosTransaction);
        }
      }
    );

    RequestHandler.get(
      `/ErpPosCollectionTransaction?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
    if (filterSummary) {
      setFilterSummary(false)
      getSummaryData()
    }
  };

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsHasExpiryDate(response.isHasExpiryDate);
      }
    });
  };

  const getColumnSettings = () => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setColumnSettings(response);
      } else {
        //erp tanımlı değilse sadece table loaderı kaldırdık
        setTableData({ ...tableData, loading: false });
      }
    });
  };


  const getColumns = () => {
    let columns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        width: 100,
        align: "center",
        render: (text) => <img src={text}></img>,
      },
      {
        title: "İşlem Tarihi",
        dataIndex: "transactionDate",
        key: "transactionDate",
        sorter: true,
        align: "center",
        render: (data) => moment(data).format("DD.MM.YYYY HH:mm"),
      },
      {
        title: "İşlem Tutarı",
        dataIndex: "amount",
        key: "amount",
        sorter: true,
        render: ColumnHelper.renderDecimal,
        align: "right"
      }
    ]

    if (columnSettings?.isSendNetAmountForMikroPosTransaction) {
      columns.push({
        title: "Komisyon Tutarı",
        dataIndex: "commissionAmount",
        key: "commissionAmount",
        sorter: true,
        render: ColumnHelper.renderDecimal,
        align: "right"
      })

      columns.push({
        title: "Net Tutar",
        dataIndex: "netAmount",
        key: "netAmount",
        sorter: true,
        render: ColumnHelper.renderDecimal,
        align: "right"
      })
    }


    columns = columns.concat([
      {
        title: "Para Birimi",
        dataIndex: "currency",
      },
      {
        title: "İşlemi Yapan",
        dataIndex: "addUserName",
        align: "center",
      },
      {
        title: "Taksit Sayısı",
        dataIndex: "installmentCount",
        align: "center",
      },
      {
        title: "Onay Kodu",
        dataIndex: "authCode",
        align: "center",
      },
      {
        title: "Müşteri Bilgisi",
        dataIndex: "customerInformation",
        align: "center"
      },
      {
        title: "Evrak No",
        dataIndex: "documentNumber",
        align: "center",
      },
      {
        title: "Cari",
        dataIndex: "firmId",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="En az 2 harf giriniz.."
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "50%" }}
            onSearch={onFirmSearch}
            onChange={(value, option) => {
              let rows = [...tableData.data];

              let rowToUpdate = {
                ...row,
                firmId: value,
                firmName: option?.firmName,
                firmClassId: option?.firmClassId,
                firmClassName: option?.firmClassName,
                firmBranchNumber: option?.firmBranchNumber,
                firmDirectiveName: option?.firmDirectiveName,
                chequeNumbers: [],
                chequeNumber: option?.chequeNumber,
              };


              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 || option.firmDirectiveName.toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {data && (
              <Select.Option
                key={row.firmId}
                value={row.firmId}
                firmName={row.firmName}
                firmClassId={row.firmClassId}
                firmBranchNumber={row.firmBranchNumber}
                firmClassName={row.firmClassName}
                firmDirectiveName={row.firmDirectiveName ?? ""}
              >
                {showFirmTitle ? row.firmBranchNumber
                  ? `${row.firmName} ${row.firmDirectiveName ? `- ${row.firmDirectiveName}` : ""} (${row.firmBranchNumber})`
                  : row.firmName : row.firmBranchNumber
                  ? `${row.firmName} (${row.firmBranchNumber})`
                  : row.firmName}

              </Select.Option>
            )}
            {firm
              .filter((item) => item.id != data)
              .map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  firmName={item.name}
                  firmClassId={item.firmClassId}
                  firmBranchNumber={item.firmBranchNumber}
                  firmClassName={item.firmClassName}
                  firmDirectiveName={item.directiveName ?? ""}
                >

                  {showFirmTitle ? item.firmBranchNumber
                    ? `${item.name}  ${item.directiveName ? `- ${item.directiveName}` : ""} (${item.firmBranchNumber})`
                    : `${item.name}` : item.firmBranchNumber
                    ? `${item.name} (${item.firmBranchNumber})`
                    : item.name}
                </Select.Option>
              ))}
          </Select>
        ),
      }
    ]);
    //  columns.push(additionalColumns);


    if (columnSettings?.isSendNetAmountForMikroPosTransaction) {
      columns.push({
        title: "Komisyon Carisi",
        dataIndex: "commissionFirmId",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="En az 2 harf giriniz.."
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "50%" }}
            onSearch={onFirmSearch}
            onChange={(value, option) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                commissionFirmId: value,
                commissionFirmName: option?.firmName,
                commissionFirmClassId: option?.firmClassId,
                commissionFirmClassName: option?.firmClassName,
                commissionFirmBranchNumber: option?.firmBranchNumber,
                commissionFirmDirectiveName: option?.firmDirectiveName
              };
              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 || option.firmDirectiveName.toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {data && (
              <Select.Option
                key={row.commissionFirmId}
                value={row.commissionFirmId}
                firmName={row.commissionFirmName}
                firmClassId={row.commissionFirmClassId}
                firmBranchNumber={row.commissionFirmBranchNumber}
                firmClassName={row.commissionFirmClassName}
                firmDirectiveName={row.commissionFirmDirectiveName ?? ""}
              >
                {showFirmTitle ? row.commissionFirmBranchNumber
                  ? `${row.commissionFirmName} ${row.commissionFirmDirectiveName ? `- ${row.commissionFirmDirectiveName}` : ""} (${row.commissionFirmBranchNumber})`
                  : row.commissionFirmName : row.commissionFirmBranchNumber
                  ? `${row.commissionFirmName} (${row.commissionFirmBranchNumber})`
                  : row.commissionFirmName}

              </Select.Option>
            )}
            {firm
              .filter((item) => item.id != data)
              .map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  firmName={item.name}
                  firmClassId={item.firmClassId}
                  firmBranchNumber={item.firmBranchNumber}
                  firmClassName={item.firmClassName}
                  firmDirectiveName={item.directiveName ?? ""}
                >
                  {showFirmTitle ? item.firmBranchNumber
                    ? `${item.name} ${item.directiveName ? `- ${item.directiveName}` : ""} (${item.firmBranchNumber})`
                    : `${item.name}` : item.firmBranchNumber
                    ? `${item.name} (${item.firmBranchNumber})`
                    : item.name}
                </Select.Option>
              ))}
          </Select>
        )
      });
    }

    if (columnSettings?.isHasProjectCode &&
      columnSettings.isHasMatchAccountTransactionRule
    ) {

      columns.push({
        title: "Proje Kodu",
        dataIndex: "transactionProjectTypeId",
        width: "15%",
        render: (data, row, index) => {

          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              defaultValue={data ?? undefined}
              disabled={!isExportAvailable}
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              loading={projects.loading}
              onSearch={onProjectSearch}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  transactionProjectTypeId: value,
                  transactionProjectTypeName: option?.name,
                  projectCode: option?.projectCode,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {data && (
                <Select.Option
                  key={row.transactionProjectTypeId}
                  value={row.transactionProjectTypeId}
                  name={row.transactionProjectTypeName}
                  projectCode={row.projectCode}
                >
                  {row.projectCode
                    ? `${row.transactionProjectTypeName} (${row.projectCode})`
                    : row.transactionProjectTypeName}
                </Select.Option>
              )}
              {projects.data
                .filter((item) => item.id != data)
                .map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    name={item.name}
                    projectCode={item.projectCode}
                  >
                    {item.name + " (" + item.projectCode + ")"}
                  </Select.Option>
                ))}
            </Select>
          );
        },
      });
    }

    if (
      columnSettings?.isHasProjectCode &&
      !columnSettings?.isHasMatchAccountTransactionRule
    ) {
      columns.push({
        title: "Proje Kodu",
        dataIndex: "projectCode",
        width: "15%",
        render: (data, row, index) => (
          <Input
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            onChange={(event) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                projectCode: event.target.value,
              };
              rows[index] = rowToUpdate;

              setTableData({ ...tableData, data: rows });
            }}
          />
        ),
      });
    }

    if (columnSettings?.isHasReferenceCode && columnSettings?.isHasReferenceCodeSelectable) {
      columns.push({
        title: "Referans Kodu",
        dataIndex: "referenceCode",
        key: "referenceCode",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            disabled={!isExportAvailable || row.firmId == null}
            value={tableDataQueryOptions.activeTab == 0 ? undefined : row.referenceCode}
            dropdownStyle={{ minWidth: "30%" }}
            loading={referenceCodes.loading}
            onSearch={onReferenceCodeSearch}
            style={{ width: "100%" }}
            onChange={(value) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                referenceCode: value,
              };
              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {referenceCodes?.data?.map((item) => (
              <Select.Option
                key={item.projectCode}
                value={item.projectCode}
                name={item.name}
                projectCode={item.projectCode}
              >
                {item.name + " (" + item.projectCode + ")"}
              </Select.Option>
            ))}
          </Select>
        ),
      });
    }

    if (columnSettings?.isHasCenterOfResponsibilityForPosCollection || columnSettings?.isSendNetAmountForMikroPosTransaction) {
      columns.push({
        title: "Sorumluluk Merkezi",
        dataIndex: "chaResponsibilityCode",
        width: "15%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              value={data ? data : defaultResponsbilityCenter && isExportAvailable ? defaultResponsbilityCenter : null}
              style={{ width: "100%" }}
              loading={responsibilityCenter.loading}
              disabled={!isExportAvailable}
              onChange={(value, option) => {
                let rows = [...tableData.data];

                let rowToUpdate = {
                  ...row,
                  chaResponsibilityCode: value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >

              {responsibilityCenter.data.map((item) => {
                return (
                  <Select.Option key={item.id} value={item.projectCode}>
                    {`${item.name} - (${item.projectCode})`}
                  </Select.Option>
                );
              })}
            </Select>
          );
        },
      });
    }
    if (columnSettings?.isHasCardType) {
      columns.push({
        title: "Banka Türü",
        dataIndex: "cardType",
        width: "10%",

        render: (data, row, index) => {
          return (
            <Select
              style={{ width: "100%" }}
              defaultValue={data ?? undefined}
              disabled={!isExportAvailable}
              allowClear
              placeholder="Seçiniz"
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  cardType: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {cardTypeSelect.map(({ key, value }) => (
                <Select.Option key={key} value={key}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }

    return columns.concat([{
      title: "Durum",
      dataIndex: "erpTransferStatusId",
      align: "center",
      render: (i, row) => {
        const icon = {
          0: {
            component: <InfoCircleOutlined />,
          },
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },
          3: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        let erpStatusText = row.erpTransferStatus;
        if (erpStatusText === "Successful") {
          erpStatusText = "Başarılı";
        } else if (erpStatusText === "Transferring") {
          erpStatusText = "Aktarılıyor";
        } else if (erpStatusText === "Unsuccessful") {
          erpStatusText = "Başarısız";
        } else if (erpStatusText === "NotTransferred") {
          erpStatusText = "Aktarılmadı";
        }

        return (
          <Tooltip
            title={
              erpStatusText === "Başarısız" ? row.errorMessage : erpStatusText
            }
          >
            {icon[i] && (
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            )}
          </Tooltip>
        );
      },
    }]);

  };



  const columns = getColumns();

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
    if (selectedKeys.length == 0)
      getSummaryData()
    else
      setSummaryDataList(tableData.data.filter((row) => selectedKeys.includes(row.id)))
  };
  const onConfirmSuccessfulExport = () => {
    const filteredData = tableData.data.filter((row) => selectedRowKeys.includes(row.id));
    setSummaryDataList(filteredData)
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (isSuccess) {
      selectedRowsData.map((item) => {
        if (item.firmClassId === null) {
          item.firmClassId = "00000000-0000-0000-0000-000000000000";
        }
        if (item.firmId === null) {
          item.firmId = "00000000-0000-0000-0000-000000000000";
        }
      });
      RequestHandler.post(
        "/ErpPosCollectionTransaction/SetSuccessfulTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    }
    setFilterSummary(true)
  };

  const onConfirmNotTransferredExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpPosCollectionTransaction/SetNotTransferredTransfer",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
    setFilterSummary(true)
  };

  const onConfirmExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    // firmBranchNumber valuesu olmayan bir firm seçili ise
    if (selectedRowsData.some((row) => !row.firmBranchNumber)) {
      notification.error({
        message:
          "Seçili POS Tahsilatları içerisinde 'Cari Kodu' olmayan Cari kayıtları var.",
        duration: 3,
      });
      isSuccess = false;
    }

    // valuesu olmayan bir tenant account hareketi seçili ise
    if (selectedRowsData.some((row) => !row.erpCode)) {
      notification.error({
        message:
          "Seçili POS Tahsilatları içerisinde 'Erp Kodu' olmayan Hesaba ait kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    selectedRowsData.forEach((row) => {
      if (row.chaResponsibilityCode == null) {
        row.chaResponsibilityCode = defaultResponsbilityCenter;
      }
    })

    if (isSuccess) {
      RequestHandler.post(
        "/ErpPosCollectionTransaction",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        } else {
          isSuccess = false;
        }
      });
    }
    setFilterSummary(true)
  };

  const onClearTableFilter = () => {
    setFilterSummary(true)
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setFilterSummary(true)
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });

    setTabKeyValue(tabKey);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={8} lg={16} xl={isBigScreen ? 17 : 15}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> POS TAHSİLAT AKTARIM
          </p>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={3}
        >
          {(isHasExpiryDate) && (
            <Button
              type="primary"
              style={{ marginBottom: 0 }}
              onClick={() => setExpiryDateModalVisible(true)}
            >
              <SendOutlined />
              Vade Günü Listele
            </Button>
          )}
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{
            textAlign: "right",
            paddingLeft: "0px",
          }}
        >
          <Popconfirm
            title={
              tableDataQueryOptions.activeTab === "0" ||
                tableDataQueryOptions.activeTab === "3"
                ? "Aktarıldı olarak işaretlensin mi?"
                : "Aktarılmadı olarak işaretlensin mi?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={!allowMarkAsTransfered || selectedRowKeys.length < 1}
            onConfirm={
              tableDataQueryOptions.activeTab === "0" ||
                tableDataQueryOptions.activeTab === "3"
                ? onConfirmSuccessfulExport
                : onConfirmNotTransferredExport
            }
            style={{ color: "seagreen" }}
          >
            {(tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "1" ||
              tableDataQueryOptions.activeTab === "3") && (
                 <Tooltip title={!allowMarkAsTransfered ? "Yetkiniz yoktur lütfen yöneticinizle görüşünüz" : "" }>
                  <Button
                    type="primary"
                    disabled={ !allowMarkAsTransfered || selectedRowKeys.length < 1}
                    style={{ marginBottom: 0 }}
                  >
                    <SendOutlined />{" "}
                    {(tableDataQueryOptions.activeTab === "0" ||
                      tableDataQueryOptions.activeTab === "3") &&
                      "Aktarıldı Yap"}
                    {tableDataQueryOptions.activeTab === "1" && "Aktarılmadı Yap"}
                  </Button>
                </Tooltip>
              )}
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{ textAlign: "right" }}
          hidden={tableDataQueryOptions.activeTab === "1"}
        >
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Erp'ye Aktar
              </Button>
            )}
          </Popconfirm>
        </Col>
      </Row>

      <ErpPosTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      ></ErpPosTransactionTableFilter>

      <ErpReportSummary data={summaryData} loading={loadingSummary} />

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="-1" />
        <Tabs.TabPane tab="Aktarılmadı" key="0" />
        <Tabs.TabPane tab="Başarılı" key="1" />
        <Tabs.TabPane tab="Aktarılıyor" key="2" />
        <Tabs.TabPane tab="Başarısız" key="3" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            rowSelection={
              isExportAvailable
                ? {
                  selectedRowKeys: selectedRowKeys,
                  onChange: onTableSelectChange,
                }
                : tableDataQueryOptions.activeTab === "1"
                  ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                  }
                  : undefined
            }
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Modal
        id="expiryDateModal"
        centered
        visible={expiryDateModalVisible}
        onOk={() => setExpiryDateModalVisible(false)}
        onCancel={() => setExpiryDateModalVisible(false)}
        width={1800}
        footer={null}
      >
        <ErpPosTransactionExpiryDateModal />
      </Modal>
    </>
  );
}

export default ErpPosTransaction;
